module.exports = __webpack_public_path__ + "assets/images/agent_142925c3d2269c3ab6223efc16010374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedback/agent.png
// module id = 188
// module chunks = 0